import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import React from 'react'
import { RegistrationButtonInterface } from 'src/shared/types/entities/registration-button-interface'
import { BaseEditorButton } from '../base-editor-button'

export interface RegistrationButtonProps {
  entity: RegistrationButtonInterface
  isMoveUpAllowed: boolean
  isMoveDownAllowed: boolean
}

export const RegistrationButton = ({
  entity,
  isMoveUpAllowed,
  isMoveDownAllowed,
}: RegistrationButtonProps) => {
  return (
    <BaseEntityNew
      entity={entity}
      flex
      flexColumn
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <BaseEditorButton entity={entity}></BaseEditorButton>
    </BaseEntityNew>
  )
}
